<template>
    <div class="position-relative">
        <div v-if="isLoggedIn && !isWishList">
            <a :href="$ceres.urls.myAccount" class="nav-link" id="accountMenuList" :aria-label="$translate('Ceres::Template.loginMyAccount')">
                <svg class="fa-user mr-0 d-lg-none" width="15px" height="15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path fill="currentColor" d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"></path>
                </svg>
                <i class="fa fa-user mr-0 d-none d-lg-inline" aria-hidden="true"></i>
            </a>
        </div>
        <div v-if="!isLoggedIn && !isWishList">
            <a class="nav-link" data-testing="login-select" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                <svg class="fa-user mr-0 d-lg-none" width="15px" height="15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path fill="currentColor" d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"></path>
                </svg>
                <i class="fa fa-user mr-0 d-none d-lg-inline" aria-hidden="true"></i>
            </a>
        </div>
        <div v-if="isLoggedIn && isWishList">
        </div>
        <div v-if="!isLoggedIn && isWishList" class="wishlist-container">
            <div class="wishlist-login-info">
                <span class="wishlist-text">{{$translate("GonserDT::Template.wishListLoginInfo")}}</span>
                <a class="nav-link login-button" data-testing="login-select" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                    {{$translate('GonserDT::Template.wishListLoginButton')}} 
                    <i class="fa fa-user" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import ValidationService from "../../../services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        },
        isWishList: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
            // isShowNewHeader: false,
            // isShowOldHeader: false
        };
    },

    // mounted()
    // {
    //     this.$nextTick(() => {
    //         this.checkBodyClasses();
    //     });
    //     const observer = new MutationObserver((mutationsList) => {
    //         for (const mutation of mutationsList) {
    //             if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
    //                 this.checkBodyClasses(); // Update isShowNewHeader and isShowOldHeader when class changes
    //             }
    //         }
    //     });

    //     // Start observing the body element for attribute changes (classes)
    //     observer.observe(document.body, { attributes: true });

    //     // Save the observer in case you want to disconnect it later (e.g. in beforeDestroy)
    //     this.observer = observer;
    // },

    // beforeDestroy() {
    //     if (this.observer) {
    //         this.observer.disconnect();
    //     }
    // },

    // watch: {
    //     isShowNewHeader(newVal) {
    //         //eslint-disable-next-line no-console
    //         // console.log('isShowNewHeader changed:', newVal);  
    //     },
    //     isShowOldHeader(newVal) {
    //         //eslint-disable-next-line no-console
    //         // console.log('isShowOldHeader changed:', newVal);
    //     }
    // },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])

        // checkBodyClasses() {
        //     if (typeof document !== 'undefined') {
        //         this.isShowNewHeader = document.body.classList.contains('showNewHeader');
        //         this.isShowOldHeader = document.body.classList.contains('showOldHeader');
        //         //eslint-disable-next-line no-console
        //         // console.log('isShowNewHeader', this.isShowNewHeader);
        //         //eslint-disable-next-line no-console
        //         // console.log('isShowOldHeader', this.isShowOldHeader);
        //     }
        // }
    }
}
</script>
